import Button from "@helsenorge/designsystem-react/components/Button";
import { useGetResources } from "../../hooks/useGetResources";
import { useLogin } from "../../../src/hooks/useLogin";
import { useRef } from "react";

export const AnonymousPage: React.FC = () => {
  const resources = useGetResources();
  const { login } = useLogin();

  const buttonRef = useRef<HTMLButtonElement>(null);

  return (
    <Button
      variant="fill"
      arrow="icon"
      ref={buttonRef}
      onClick={() => login(buttonRef)}
    >
      {resources?.loginbutton || ""}
    </Button>
  );
};
